module.exports = __webpack_public_path__ + "components/flag/static/square/bg-447673d0ea1420d57715057f2131142a.svg";